<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>
          </div>

          <button type="button" *ngIf="params.storeIds" (click)="generate()" class="btn btn-outline-success m--margin-top-15 m--margin-right-10"
                  [disabled]="isLoading.generate" [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.generate}">
            {{ 'download' | transloco }}
          </button>

          <button type="button" (click)="resetFilter()" class="btn btn-outline-primary m--margin-top-15">
            {{ 'reset.list' | transloco }}
          </button>

          <div *ngIf="pls && !isLoading.pls && spendingEntries.length > 0" class="block-table-scroll m--margin-top-30">
            <table class="m--margin-top-10 m--margin-bottom-40 table-report" style="width:100%; border-collapse: collapse;">
              <thead>
              <tr class="fixed-head-oline">
                <th class="text-left fixed-head-one m--padding-10"></th>
                <th class="text-center fixed-head-two m--padding-10">{{ 'report.total' | transloco }}</th>
              </tr>
              </thead>
              <tbody>

              <!-- Доходы -->
              <tr class="section-header-income">
                <td class="bold-main" colspan="2">{{ 'profit-loss-statement.income' | transloco }}</td>
              </tr>
              <ng-container *ngFor="let entry of incomeEntries">
                <tr>
                  <td class="bold-main indent-1">{{ entry.title | uiLabel }}</td>
                  <td class="text-right">{{ getValueByCode(entry.code) | number }}</td>
                </tr>
                <ng-container *ngFor="let child of entry.childEntries">
                  <tr>
                    <td class="indent-2 child-entry">{{ child.title | uiLabel }}</td>
                    <td class="text-right">{{ getValueByCode(child.code) | number }}</td>
                  </tr>
                </ng-container>
              </ng-container>

              <tr>
                <td class="bold-main indent-1">{{ 'profit-loss-statement.totalIncome' | transloco }}</td>
                <td class="text-right bold-main">{{ totalIncome | number }}</td>
              </tr>
              <tr>
                <td class="bold-main indent-1">{{ 'profit-loss-statement.costPrice' | transloco }}</td>
                <td class="text-right bold-main">{{ costPrice | number }}</td>
              </tr>

              <!-- Себестоимость children -->
              <ng-container *ngFor="let entry of spendingEntries">
                <ng-container *ngIf="entry.code === 'cogs'">
                  <ng-container *ngFor="let child of entry.childEntries">
                    <tr>
                      <td class="indent-2 child-entry">{{ child.title | uiLabel }}</td>
                      <td class="text-right">{{ getValueByCode(child.code) | number }}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>

              <tr class="summary-row">
                <td class="bold-main indent-1">{{ 'profit-loss-statement.grossProfit' | transloco }}</td>
                <td class="text-right bold-main">{{ grossProfit | number }}</td>
              </tr>

              <!-- Расходы -->
              <tr class="section-header-expenses">
                <td class="bold-main" colspan="2">{{ 'profit-loss-statement.expenses' | transloco }}</td>
              </tr>
              <ng-container *ngFor="let entry of expenseEntries">
                <tr>
                  <td class="bold-main indent-1">{{ entry.title | uiLabel }}</td>
                  <td class="text-right">{{ getEntryTotal(entry) | number }}</td>
                </tr>
                <ng-container *ngFor="let child of entry.childEntries">
                  <tr>
                    <td class="indent-2 child-entry">{{ child.title | uiLabel }}</td>
                    <td class="text-right">{{ getValueByCode(child.code) | number }}</td>
                  </tr>
                </ng-container>
              </ng-container>

              <tr class="summary-row">
                <td class="bold-main indent-1">{{ 'profit-loss-statement.totalExpenses' | transloco }}</td>
                <td class="text-right bold-main">{{ totalExpenses | number }}</td>
              </tr>

              <!-- Итоги -->
              <tr>
                <td class="bold-main indent-1">{{ 'profit-loss-statement.profitBeforeTax' | transloco }}</td>
                <td class="text-right bold-main">{{ profitBeforeTax | number }}</td>
              </tr>
              <tr>
                <td class="bold-main indent-1">{{ 'profit-loss-statement.taxesProfit' | transloco }}</td>
                <td class="text-right bold-main">{{ taxesProfit | number }}</td>
              </tr>
              <tr>
                <td class="bold-main indent-1">{{ 'profit-loss-statement.netProfit' | transloco }}</td>
                <td class="text-right bold-main">{{ netProfit | number }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
